import { useTranslation } from "react-i18next";
import { ArrowUpRightIcon, ArrowDownRightIcon } from "@phosphor-icons/react";

import { formatDiffValue, getDiffDirection } from "./field-diff-row.helpers";

import styles from "./field-diff-row.module.css";

import type { FieldDiffRowProps } from "./field-diff-row.type";

export const FieldDiffRow = ({ label, diff }: FieldDiffRowProps) => {
  const { t } = useTranslation();

  const oldFormatted = formatDiffValue(diff.oldValue, diff.formatter, t);
  const newFormatted = formatDiffValue(diff.newValue, diff.formatter, t);
  const direction = getDiffDirection(diff.oldValue, diff.newValue);

  return (
    <div className={styles.row}>
      <span className={styles.label}>{label}</span>

      <div className={styles.values}>
        <span className={styles.old}>{oldFormatted}</span>

        {direction === true && (
          <ArrowUpRightIcon
            size={16}
            weight="bold"
            className={styles["arrow-up"]}
          />
        )}
        {direction === false && (
          <ArrowDownRightIcon
            size={16}
            weight="bold"
            className={styles["arrow-down"]}
          />
        )}

        <span className={styles.new}>{newFormatted}</span>
      </div>
    </div>
  );
};
